"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var components_1 = require("components");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        display: 'flex',
        width: '100%',
        minHeight: 64,
        backgroundColor: styles_1.BackgroundColor.White,
        alignItems: 'center',
        zIndex: 10000,
    },
    icon: {
        marginLeft: 11,
    },
    title: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 11,
        fontSize: 24,
        fontWeight: 400,
    },
};
var getStyle = function (style, props) { return ([
    style.base,
    props.style,
]); };
var AppBar = (function (_super) {
    __extends(AppBar, _super);
    function AppBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleToggleDrawerClick = function () {
            _this.props.onToggleDrawerClick();
        };
        return _this;
    }
    AppBar.prototype.render = function () {
        var otherProps = __rest(omit(this.props, [
            'toggleDrawerIconColor',
            'hideToggleDrawerIconButton',
            'style',
            'onToggleDrawerClick',
        ]), []);
        return (React.createElement(components_1.Paper, __assign({ style: getStyle(componentStyle, this.props) }, otherProps),
            this.renderToggleDrawerIconButton(),
            this.renderTitle()));
    };
    AppBar.prototype.renderTitle = function () {
        var title = this.props.title;
        return title
            ? React.createElement("h1", { style: componentStyle.title }, title)
            : null;
    };
    AppBar.prototype.renderToggleDrawerIconButton = function () {
        var _a = this.props, hideToggleDrawerIconButton = _a.hideToggleDrawerIconButton, toggleDrawerIconColor = _a.toggleDrawerIconColor;
        if (hideToggleDrawerIconButton) {
            return null;
        }
        return (React.createElement(components_1.IconButton, { style: componentStyle.icon, iconColor: toggleDrawerIconColor, iconName: "menu", flat: true, onClick: this.handleToggleDrawerClick }));
    };
    AppBar.defaultProps = {
        onToggleDrawerClick: function () { return; },
    };
    AppBar = __decorate([
        Radium
    ], AppBar);
    return AppBar;
}(react_1.PureComponent));
exports.AppBar = AppBar;



//////////////////
// WEBPACK FOOTER
// ./src/components/AppBar/AppBar.tsx
// module id = 230
// module chunks = 0